module.exports = __webpack_public_path__ + "static/media/workingmemory-words-5.cc4645b7.mp3";